import React from 'react'
import { useTranslate } from '../TranslationText'
import NewActionButton from '../ActionButtons/NewActionButton';
import { eformApproveAndPay } from '../../common/cssclasses';
import { isAssistant } from '../../helper/IsAssistant';

export default function ApproveAndPayLaterBtn({ selectedAccountId, isApprove = true, ...props }) {
    const { translate } = useTranslate();
    const assistant = isAssistant(selectedAccountId);
    if (assistant) {
        return (<></>);
    }

    return (
        <div className={eformApproveAndPay}>
            <NewActionButton
                text={
                    <>
                        <i class="fa-solid fa-wallet"></i>
                        {isApprove ? translate("web.approveAndPayLater", "Approve And Pay Later") : translate("web.payLater", "Pay Later")}
                    </>
                }
                {...props}
            />
        </div>
    )
}
